<kpd-side-panel
  [facade]="roleFacade"
  [entityName]="'Role' | translate"
  class="roles__sidepanel"
  (itemChanged)="onItemChange($event)"
>
  <ng-template kpdTemplate="actionbar" let-selection let-loading="loading" let-deleted="deleted">
    <kpd-action-create
      *kpdPermission="Permissions.RoleCreate"
      (action)="onAdd()"
      [title]="'Add role' | translate"
    ></kpd-action-create>
    <ng-container *ngIf="selection.length !== 0 && !deleted">
      <kpd-action-consult-overview (action)="onView(selection[0])" [disable]="loading"></kpd-action-consult-overview>
      <kpd-action-edit-toggle
        *kpdPermission="Permissions.RoleUpdate"
        (action)="onEdit(selection[0])"
        [disable]="loading"
        [readMode]="false"
      ></kpd-action-edit-toggle>
      <kpd-action-delete
        *kpdPermission="Permissions.RoleDelete"
        (action)="onDelete(selection)"
        [disable]="loading"
      ></kpd-action-delete>
    </ng-container>
  </ng-template>

  <ng-template kpdTemplate="singleItem" let-item>
    <h3 translate>General</h3>
    <div class="flex-row flex-wrap">
      <div class="flex-column">
        <div class="read-group flex-row read-sidepannel">
          <label class="title" translate>Application</label>
          <label class="value">{{ item.application | kpdDefault }}</label>
        </div>
        <div class="read-group flex-row read-sidepannel">
          <label class="title" translate>Name</label>
          <label class="value">{{ item.name | kpdDefault }}</label>
        </div>
        <div class="read-group flex-row read-sidepannel">
          <label class="title" translate>Is assigned by default</label>
          <kpd-check [checked]="item.isAssignedByDefault"></kpd-check>
        </div>
      </div>
    </div>
    <div *ngIf="item.permissionSets && item.permissionSets.length > 0">
      <h3 translate class="permissionSets__title">Permission sets</h3>
      <div class="flex-row flex-wrap">
        <div class="flex-column permissionSets">
          <div *ngFor="let permissionSet of item.permissionSets" class="permissionSet">
            {{ permissionSet.name }}
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template kpdTemplate="multiItem" let-item>
    <div class="card-small">
      <label class="card__header">
        <span class="card__multival flex-row">
          <b>{{ item.name }}</b
          >&nbsp;-&nbsp;{{ item.application }}
        </span>
      </label>
    </div>
  </ng-template>
  <ng-template kpdTemplate="tiles" let-item>
    <div>
      <kpd-tile
        icon="unlock"
        [title]="'Permission sets' | translate"
        [value]="item.permissionSets ? item.permissionSets.length : 0"
        (click)="navigateToPermissionSets(item.key)"
      ></kpd-tile>
    </div>
    <kpd-tile
      *kpdPermission="Permissions.UserRead"
      icon="user"
      [title]="'Users' | translate"
      [value]="userCount"
      (click)="navigateToUsers(item.key)"
    ></kpd-tile>
  </ng-template>
  <kpd-side-panel> </kpd-side-panel
></kpd-side-panel>
